export enum AddPaymentDialogType {
  MAIN = 'MAIN',
  CREDITCARD = 'CREDITCARD',
  CREDITCARD_MOTO = 'CREDITCARD_MOTO',
  WERO = 'WERO',
  SEPA = 'SEPA',
  SEPA_BLACKLIST = 'SEPA_BLACKLIST',
  KLARNA = 'KLARNA',
  DIRECTTRANSFER = 'DIRECTTRANSFER',
  PAYPAL = 'PAYPAL',
  APPLEPAY = 'APPLEPAY',
  GOOGLEPAY = 'GOOGLEPAY'
}
